import Vue from 'vue';
import config from '../../config/index';

export default {
  // 获取在线用户列表
  getOnlineUserList(params) {
    return Vue.axios.get(`${config.base_url}/roses-platform/sysOnlineUser/page`, { params });
  },
  // 强制下线  
  postForceLogout(params) {
    return Vue.axios.post(`${config.base_url}/roses-platform/sysOnlineUser/forceExist`, params);
  }
};